export default __webpack_public_path__ + "static/media/login-pic.fc318e8e.svg";